import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './sic-prefooter.css.lit';
import { SlotsController } from '../../controllers/slots-controller';

/**
 * The Prefooter
 *
 * @element sic-prefooter
 *
 * @slot prefooter-icon
 * @slot title
 * @slot text
 * @slot cta
 *
 */
@customElement('sic-prefooter')
export class SicPrefooter extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  ngSlot = new SlotsController(this);

  @property({ type: String })
  icon = null;

  /*
   * If slot exist - add it with div wrapper and additional classes
   */
  conditionalNGSlot(
    slotName: string,
    renderInShadow = true,
    classes: string | null = null
  ) {
    if (this.ngSlot.slotExists(slotName)) {
      return html` <div class="${slotName} ${classes}">
        ${renderInShadow
          ? html`${this.ngSlot.renderInShadow(slotName)}`
          : html`<slot name=${slotName}></slot> `}
      </div>`;
    } else {
      return null;
    }
  }

  render(): TemplateResult {
    return html`
      <div class="prefooter-wrapper">
        <span class="blue-row2"></span>
        <span class="white-row1"></span>
        <span class="white-column1"></span>
        ${this.conditionalNGSlot('prefooter-icon', true)}
        <div class="text-wrapper">
          ${this.conditionalNGSlot('title', true)}
          ${this.conditionalNGSlot('text', false)}
          ${this.conditionalNGSlot('cta', false)}
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-prefooter': SicPrefooter;
  }
}
